import type { StringUnion } from '../../../../typescript';
import { BaseUrl } from '../../base-urls';

import { isResearchV2Url } from './is-v2-url';

const makeResearchV2ApiHeaders = (url: string, baseUrl?: StringUnion<BaseUrl>) => {
    const apiKey = process.env.RESEARCH_V2_API_KEY;
    if (apiKey && isResearchV2Url(url, baseUrl)) {
        return { 'X-Api-Key': apiKey };
    }
    return;
};

export { makeResearchV2ApiHeaders };
